(function() {
    'use strict';

    angular
        .module('cloudApp')
        .service('InviteService', InviteService);

    InviteService.$inject = ['$http'];

    function InviteService($http) {
        this.getInvite = function getInvite(invite){
            return $http.get(SERVER_API_URL+'api/invites/'+invite);
        }

        /*this.sendInviteAdmin = function sendInvite(account, company, instance){
            return $http.post(SERVER_API_URL+'api/registerdbhawkadmin/'+company+'/'+instance, account);
        }*/
    }
})();
